import api from "./axios";
import type { ActionsListResponse, ActionDetailResponse, ParticipantResponse } from '../dto/actions-dto';
import type SaveResponse from '../dto/SaveResponse';

export const getActionListRequest = async (
  isPlanned: boolean
): Promise<ActionsListResponse[]> => {
  const response = await api.get<ActionsListResponse[]>('/actions', {
    params: { isplanned: isPlanned }
  });
  return response.data;
};

export const getActionDetailRequest = async (
  id: number | string
): Promise<ActionDetailResponse> => {
  const response = await api.get<ActionDetailResponse>(`/actions/${id}`);
  return response.data;
};

export const saveActionDetailRequest = async (
  action: ActionDetailResponse
): Promise<SaveResponse> => {
  const response = await api.post<SaveResponse>('/actions/save', action);
  return response.data;
};

export const deleteActionDetailRequest = async (
  id: number | string
): Promise<SaveResponse> => {
  const response = await api.delete<SaveResponse>(`/actions/${id}`);
  return response.data;
};

export const getParticipantListRequest = async (
  idAction: number
): Promise<ParticipantResponse[]> => {
  const response = await api.get<ParticipantResponse[]>('/participant', {
    params: { idaction: idAction }
  });
  return response.data;
};

export const getParticipantDetailRequest = async (
  id: number | string
): Promise<ParticipantResponse> => {
  const response = await api.get<ParticipantResponse>(`/participant/${id}`);
  return response.data;
};

export const saveParticipantRequest = async (
  request: ParticipantResponse
): Promise<SaveResponse> => {
  const response = await api.post<SaveResponse>('/participant/save', request);
  return response.data;
};

export const deleteParticipantRequest = async (
  id: number | string
): Promise<SaveResponse> => {
  const response = await api.delete<SaveResponse>(`/participant/${id}`);
  return response.data;
};

